// Live "does this extension have a mailbox on the PBX" map, keyed by
// sip_account id. One request per page, one agent call per host behind it,
// KV-cached ~60s server-side — the same arrangement as useRegistrations.
//
// Shared hook rather than a query per page so the query key is identical
// everywhere and React Query serves one fetch to every consumer on screen.

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export function useVoicemailStatus({ enabled = true } = {}) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['voicemail-status'],
    queryFn: () => api.get('/voicemail-status'),
    enabled,
    // Slower than registrations: a mailbox's existence changes when someone
    // changes it, not second to second.
    refetchInterval: 5 * 60_000,
    staleTime: 60_000,
  });

  const status = data?.status || {};
  return {
    status,
    // `entryFor` keeps callers from having to remember the map is keyed by id as
    // a string in JSON but a number in our rows.
    entryFor: (sipAccountId) => status[String(sipAccountId)] ?? status[sipAccountId] ?? null,
    // Hosts we couldn't reach, so a page can say "couldn't read PBX-01" instead
    // of rendering every extension as unknown with no explanation.
    hostErrors: data?.host_errors || null,
    isLoading,
    error,
  };
}
